export const replaceLastCharacter = (str, replacement) => {
    if (!str.length) return str;
    return `${str.slice(0, -1)}${replacement}`;
};

export const generateAbbreviatedTeamName = (teamName) => {
    return (
        teamName
            ?.substring(0, 8)
            .toUpperCase()
            .replace(/[^a-zA-Z0-9]/g, "_")
            .replace(/_+$/, "") || ""
    );
};

export const generateAbbreviatedTeamNames = (awayTeam, homeTeam) => {
    const awayAbbrTeamName = generateAbbreviatedTeamName(awayTeam.teamName);
    let homeAbbrTeamName = generateAbbreviatedTeamName(homeTeam.teamName);
    if (awayAbbrTeamName === homeAbbrTeamName) {
        homeAbbrTeamName = replaceLastCharacter(homeAbbrTeamName, "1");
    }

    return { awayAbbrTeamName, homeAbbrTeamName };
};
